<div class="w-full h-full bg-[#232323] text-white min-h-screen overflow-auto">
    <!-- Header -->
    <div class="px-8 md:px-16 pt-12 pb-6">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
                <h1 class="text-4xl font-extrabold mb-2">Newsletter</h1>
                <p class="text-lg text-white/70">Fique por dentro das últimas notícias e novidades do mercado imobiliário.</p>
            </div>
            
            @if (isAdmSistema) {
                <button 
                    mat-flat-button 
                    class="bg-[#E4811E] hover:bg-[#d4751a] text-white px-6 py-2"
                    (click)="abrirForm()">
                    <mat-icon svgIcon="heroicons_outline:plus" class="icon-size-5 mr-2"></mat-icon>
                    Nova Newsletter
                </button>
            }
        </div>
    </div>

    <!-- Filtros -->
    <div class="px-8 md:px-16 pb-6">
        <div class="flex flex-col md:flex-row md:items-center gap-4">
            <!-- Tags de Tópicos -->
            <div class="flex flex-wrap gap-2 flex-1">
                <button
                    class="px-4 py-2 text-sm font-medium rounded-full transition-all duration-200"
                    [ngClass]="selectedTopicId === null ? 'bg-[#E4811E] text-white' : 'bg-zinc-800 text-white/70 hover:bg-zinc-700 border border-zinc-700'"
                    (click)="selectedTopicId = null">
                    Todas
                </button>
                @for (topic of topics; track topic.id) {
                    <button
                        class="px-4 py-2 text-sm font-medium rounded-full transition-all duration-200"
                        [ngClass]="selectedTopicId === topic.id ? 'bg-[#E4811E] text-white' : 'bg-zinc-800 text-white/70 hover:bg-zinc-700 border border-zinc-700'"
                        (click)="selectTopic(topic)">
                        {{ topic.nome }}
                    </button>
                }
            </div>

            <!-- Campo de Busca -->
            <div class="relative w-full md:w-80">
                <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <mat-icon svgIcon="heroicons_outline:magnifying-glass" class="text-white/50 icon-size-5"></mat-icon>
                </div>
                <input
                    type="text"
                    [(ngModel)]="filtro"
                    placeholder="Pesquisar newsletters..."
                    class="w-full bg-zinc-800 text-white text-sm rounded-lg pl-12 pr-4 py-3 border border-zinc-700 focus:outline-none focus:border-[#E4811E] focus:ring-1 focus:ring-[#E4811E] transition-all duration-200 placeholder:text-white/50"
                />
            </div>
        </div>
    </div>

    <!-- Contador de Resultados -->
    <div class="px-8 md:px-16 pb-4">
        <p class="text-white/50 text-sm">
            {{ filteredNews().length }} newsletter(s) encontrada(s)
            @if (selectedTopicId !== null) {
                <span class="text-[#E4811E]"> em "{{ getTopicName(selectedTopicId) }}"</span>
            }
        </p>
    </div>

    <!-- Grid de Newsletters -->
    <div class="px-8 md:px-16 pb-12">
        @if (filteredNews().length > 0) {
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                @for (item of filteredNews(); track item.id) {
                    <div 
                        class="bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden hover:border-[#E4811E]/50 hover:shadow-lg hover:shadow-[#E4811E]/10 transition-all duration-300 cursor-pointer group"
                        (click)="abrirModal(item.id)">
                        
                        <!-- Imagem de Capa -->
                        <div class="relative h-48 bg-zinc-800 overflow-hidden">
                            @if (item.imagemUrl || item.arquivoBase64) {
                                <img 
                                    [src]="item.imagemUrl || item.arquivoBase64" 
                                    [alt]="item.titulo"
                                    class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300">
                            } @else {
                                <div class="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#E4811E]/20 to-zinc-800">
                                    <mat-icon svgIcon="heroicons_outline:newspaper" class="text-[#E4811E]/50 icon-size-16"></mat-icon>
                                </div>
                            }
                            
                            <!-- Tag do Tópico -->
                            @if (item.topicoId) {
                                <div class="absolute top-3 left-3">
                                    <span class="px-3 py-1 bg-[#E4811E] text-white text-xs font-medium rounded-full">
                                        {{ getTopicName(item.topicoId) }}
                                    </span>
                                </div>
                            }
                        </div>
                        
                        <!-- Conteúdo -->
                        <div class="p-5">
                            <h3 class="text-lg font-bold text-white mb-2 line-clamp-2 group-hover:text-[#E4811E] transition-colors">
                                {{ item.titulo }}
                            </h3>
                            
                            <p class="text-white/60 text-sm mb-4 line-clamp-3">
                                {{ item.texto }}
                            </p>
                            
                            <div class="flex items-center justify-between text-white/40 text-xs">
                                <div class="flex items-center gap-2">
                                    <mat-icon svgIcon="heroicons_outline:calendar" class="icon-size-4"></mat-icon>
                                    <span>{{ item.dataCriacao | date:'dd/MM/yyyy' }}</span>
                                </div>
                                
                                <div class="flex items-center gap-1 text-[#E4811E] group-hover:translate-x-1 transition-transform">
                                    <span class="text-xs font-medium">Ler mais</span>
                                    <mat-icon svgIcon="heroicons_outline:arrow-right" class="icon-size-4"></mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        } @else {
            <!-- Estado Vazio -->
            <div class="flex flex-col items-center justify-center py-20 text-center">
                <div class="w-24 h-24 rounded-full bg-zinc-800 flex items-center justify-center mb-6">
                    <mat-icon svgIcon="heroicons_outline:newspaper" class="text-[#E4811E] icon-size-12"></mat-icon>
                </div>
                <h3 class="text-xl font-bold text-white mb-2">Nenhuma newsletter encontrada</h3>
                <p class="text-white/50 max-w-md">
                    @if (filtro || selectedTopicId !== null) {
                        Tente ajustar seus filtros ou buscar por outro termo.
                    } @else {
                        Ainda não há newsletters publicadas. Volte em breve para novidades!
                    }
                </p>
            </div>
        }
    </div>
</div>
